import type { DomainKey } from '@/lib/domain-config';

/**
 * Per-domain glossary dictionaries. Words are replaced case-sensitively
 * at word boundaries so partial matches (e.g. "Abiturzeugnis") are safe.
 *
 * - `de`: source language, no-op
 * - `at`: Austrian German conventions
 * - `ch`: empty for now (German-only focus)
 * - `ien`: same as de (no-op)
 */
const GLOSSARY: Partial<Record<DomainKey, Record<string, string>>> = {
  at: {
    Abitur: 'Matura',
    Abiturienten: 'Maturanten',
    Klausur: 'Schularbeit',
    Klausuren: 'Schularbeiten',
  },
};

export function applyGlossary(text: string, domainKey: DomainKey): string {
  const dict = GLOSSARY[domainKey];
  if (!dict) {
    return text;
  }
  // Sort by length descending so longer terms match before shorter ones
  // (e.g. "Abiturienten" before "Abitur"). Use word-boundary regex so
  // partial matches inside longer words (e.g. "Abiturzeugnis") are safe.
  const entries = Object.entries(dict).sort(([a], [b]) => b.length - a.length);
  let result = text;
  for (const [source, target] of entries) {
    const re = new RegExp(`\\b${source}\\b`, 'g');
    result = result.replace(re, target);
  }
  return result;
}
